function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import Pill from "./Pill";
import { color } from "../../styles/theme";
import { PILL_TYPE, PILL_SIZE } from "./Pill";
var STATUS_COLORS = {
  error: color.danger,
  warning: color.warning,
  success: color.success,
  info: color.info,
  "default": color.lightGrayText
};
export default function StatusPill(_ref) {
  var htmlAttributes = _ref.htmlAttributes,
      label = _ref.label,
      rootClassName = _ref.rootClassName,
      size = _ref.size,
      status = _ref.status,
      styleAlt = _ref.style,
      tag = _ref.tag,
      type = _ref.type;
  var filled = type === PILL_TYPE.FILLED;
  var style = filled ? _objectSpread({}, styleAlt, {
    color: color.white,
    fontWeight: 'bold'
  }) : styleAlt;
  return React.createElement(Pill, {
    size: size,
    type: type,
    borderColor: STATUS_COLORS[status],
    fillColor: filled ? STATUS_COLORS[status] : undefined,
    label: label,
    tag: tag,
    rootClassName: rootClassName,
    style: style,
    htmlAttributes: htmlAttributes
  });
}
StatusPill.defaultProps = {
  size: PILL_SIZE.MD,
  type: PILL_TYPE.OUTLINE,
  status: 'default',
  tag: 'span'
};